export default __webpack_public_path__ + "static/banner-media-release-dec4-genoapay-2e0f3d384eb4283d2b061417491daeb5.jpg";